import { IconCircle, IconCircleCheckFilled } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';
import { useParams } from 'react-router-dom';

import BaseBadge, { BADGE_COLOR_MAP } from '@/components/ui/BaseBadge';
import { FollowUpEntity } from '@/entities/FollowUp';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';
import { useDevices } from '@/utils/devices';

import s from './FollowUpBadge.module.scss';

type Props = {
  model: FollowUpEntity;
  className?: string;
};

const FollowUpBadge: React.FC<Props> = ({ model, className }) => {
  const { isCompactViewport } = useDevices();

  const { followUpId } = useParams();
  const isActive = followUpId === String(model.id);
  const {
    followUp: { updateFollowUp },
  } = useSidebarNoteStore();

  const handleUpdate = React.useCallback(() => {
    updateFollowUp.update(model);
  }, [model, updateFollowUp]);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      handleUpdate();
    },
    [handleUpdate],
  );

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      handleUpdate();
    },
    [handleUpdate],
  );

  if (model.isDone) {
    return (
      <div role="button" tabIndex={0} onClick={handleClick} onKeyDown={handleKeyDown} className={cn(s.root, className)}>
        <IconCircleCheckFilled color="#12b886" size={16} />
        <BaseBadge className={s.root__badge} color={BADGE_COLOR_MAP.CLOSED}>
          Закрыт
        </BaseBadge>
      </div>
    );
  }

  return (
    <div role="button" tabIndex={0} onClick={handleClick} onKeyDown={handleKeyDown} className={cn(s.root, className)}>
      {isActive && !isCompactViewport && <IconCircle className={s.root__icon} size={16} />}
      {isCompactViewport && <IconCircle className={s.root__icon} size={16} />}
      <BaseBadge className={s.root__badge} color={BADGE_COLOR_MAP.ACTIVE}>
        Открыт
      </BaseBadge>
    </div>
  );
};

export default React.memo(FollowUpBadge);
